// src/pages/Logistics.jsx
import React from 'react';

const Logistics = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Logistics & Travel Information</h1>
      <p>Practical guidance on visa requirements, transportation, and planning your journey.</p>
    </div>
  );
};
export default Logistics;